import store from '../store';
import ROLES from './roles';
import API_ROLES from './apiRoles';
import { Api, Codes } from '../api';
import { cleanCache } from '../api/caches';
import { LOGIN_DATA_KEYS, LOGIN_LAST_TYPE_KEY } from '../constants/role';
import { Message } from 'element-ui';
import Gio from './gio';
import Teacher from './teacher';
import School from './school';
import Student from './student';
import SL from './sl';
import { getRequest } from './string';
import getCurrentLoginRole from './currentLoginRole';
const MP_LOGIN_KEY = 'mp_login_key';
class Login {
  constructor() {
    this.teacher = Teacher;
    this.school = School;
    this.student = Student;
    this.sl = SL;
    this.store = store;
  }
  get ROLES() {
    return ROLES;
  }
  get API_ROLES() {
    return API_ROLES;
  }
  get lastRole() {
    return store.state.lastLoginType;
  }
  get lastLoginData() {
    switch (this.lastRole) {
      case ROLES.STUDENT:
        return store.state.studentLoginData;
      case ROLES.TEACHER:
        return store.state.teacherLoginData;
      case ROLES.SL:
        return store.state.slLoginData;
      case ROLES.SCHOOL:
        return store.state.schoolLoginData;
      default:
        return store.state.studentLoginData;
    }
  }
  /**
   * @description 获取角色key
   * @function getRoleKey
   * @param {String} role 角色key
   * @return {String} 角色key
   */
  getRoleKey(role = ROLES.STUDENT) {
    return LOGIN_DATA_KEYS[role];
  }
  /**
   * @description 设置登出/清空登录数据
   * @function setLogout
   * @param {String} role 角色key
   */
  setLogout(role = ROLES.STUDENT) {
    this.cleanMpLoginKey();
    store.dispatch('logout', role);
    this.store.dispatch('setLanguage', 'zh-CN');
    Gio.cleanUser();
  }
  /**
   * @func redirectToLogin 页面跳转到登陆页
   */
  redirectToLogin() {
    let pathName = window.location.pathname;
    let href = window.location.pathname + encodeURIComponent(window.location.search);
    let path = '/register';
    if (pathName.indexOf('login') < 0) {
      window.location.href = `${path}?r=${href}`;
    }
    // window.location.href = `${path}?${this.directKey}=${href}`;
  }
  /**
   * @description 设置登录状态/记录登录数据
   * @function setLogin
   * @param {Object} loginData 登录数据
   * @param {String} 角色key
   */
  async setLogin(role = ROLES.STUDENT, token) {
    let data = {
      role,
      token
    };
    this.store.dispatch('setToken', data);
    // Gio.sendUser();
  }
  getCommonLoginData() {
    let lastType = this.lastRole;
    switch (lastType) {
      case ROLES.STUDENT:
        return this.student.getInfo();
      case ROLES.TEACHER:
        return this.teacher.getInfo();
      case ROLES.SCHOOL:
        return this.school.getInfo();
      case ROLES.SL:
        return this.sl.getInfo();
    }
  }
  firstToUpper(str) {
    let ret = str.trim();
    ret = ret.toLowerCase();
    ret = ret.replace(ret[0], ret[0].toUpperCase());
    return ret;
  }
  /**
   * @description 判断当前是否某种用户下登录
   * @function isLogin
   * @param {String} role 角色key
   * @return {Boolean} 是否登录
   */
  isLogin(role = ROLES.STUDENT) {
    let ret = !!store.state[`${role}_TOKEN`];
    return ret;
  }
  /**
   * 与 {@link api/factory.js} `getCurrentToken` 一致：`LAST_LOGIN_ROLE` 且对应 token 存在时返回 role。
   *
   * @returns {string|null} `ROLES.*` 或 `null`
   */
  getCurrentLoginRole() {
    return getCurrentLoginRole();
  }
  isTeacherLogin() {
    return this.isLogin(ROLES.TEACHER);
  }
  teacherPermitted() {
    if (!this.isTeacherLogin()) {
      Message.error('无权限访问！');
      let href = window.location.pathname + encodeURIComponent(window.location.search);
      let path = '/login';
      setTimeout(() => {
        window.location.href = `${path}?r=${href}`;
      }, 1000);
    }
  }
  /**
   * @description 获取status数据
   * @function getStatusData
   * @param {String} role 角色 默认student
   * @param {Boolean} force 是否强制从接口获取 默认false
   * @return {Object} statusData
   */
  async getStatusData(role = ROLES.STUDENT, force = false) {
    let getKey = '';
    switch (role) {
      default:
        getKey = 'getStudentStatus';
        break;
    }
    let ret = store.getters[getKey];
    if (force) {
      ret = null;
      cleanCache();
    }
    if (!ret) {
      if (this.isLogin(role)) {
        let res = await Api.get.getUserStatus();
        if (res.status === Codes.SUCCESS) {
          store.dispatch('setStatusData', {
            role: role,
            status: res.data
          });
        }
        ret = res.data;
      }
    }
    ret = ret || {};
    return ret;
  }
  cleanStatusData(role = ROLES.STUDENT) {
    store.dispatch('setStatusData', {
      role,
      status: null
    });
  }
  async setLoginInfoData(role = ROLES.STUDENT) {
    let res = await Api.get.getStudentInfo();
    if (res.status === Codes.SUCCESS) {
      let data = res.data;
      this.store.dispatch('setLoginData', {
        role,
        data
      });
    }
  }
  setUrlLogin() {
    let json = getRequest().login_data;
    if (json && json !== '') {
      json = decodeURIComponent(json);
      let data = JSON.parse(json);
      if (data && data.token) {
        cleanCache();
        this.cleanStatusData();
        this.setLogin(ROLES.STUDENT, data.token);
      }
    }
  }
  /**
   * @description 初始化小程序登录
   * @function initCheckMpLogin
   */
  async initCheckMpLogin() {
    return new Promise(resolve => {
      let key = localStorage.getItem(MP_LOGIN_KEY);
      // 存在key且未登录
      if (key && !this.isLogin()) {
        this.checkMpLogin(key).then(res => {
          if (res.status === Codes.SUCCESS) {
            const token = res.data.token;
            this.cleanMpLoginKey();
            cleanCache();
            this.cleanStatusData();
            this.setLogin(ROLES.STUDENT, token);
          }
          resolve(res);
        });
      }
    });
  }
  /**
   * @description 轮询小程序登录
   * @function checkMpLogin
   */
  checkMpLogin() {
    if (this.pollingPromise) {
      return this.pollingPromise;
    }
    this.pollingPromise = new Promise((resolve, reject) => {
      let key = localStorage.getItem(MP_LOGIN_KEY);
      if (key) {
        // 轮询
        let polling = () => {
          const newKey = localStorage.getItem(MP_LOGIN_KEY);
          // 如果key发生变化,使用新的key
          if (newKey && newKey !== key) {
            key = newKey;
          }
          Api.get
            .getLoginMp({
              scene_id: key
            })
            .then(res => {
              if (res.status === Codes.SUCCESS && res.data?.token) {
                this.pollingPromise = null;
                if (this.pollingTimer) {
                  clearTimeout(this.pollingTimer);
                  this.pollingTimer = null;
                }
                resolve(res);
              } else {
                this.pollingTimer = setTimeout(() => {
                  polling();
                }, 3000);
              }
            });
        };
        polling();
      } else {
        resolve({ status: Codes.ERR, message: 'key不存在' });
      }
    });
    return this.pollingPromise;
  }
  /**
   * @description 保存小程序登录key
   * @function saveMpLoginKey
   * @param {String} key 小程序登录key
   */
  saveMpLoginKey(key) {
    localStorage.setItem(MP_LOGIN_KEY, key);
  }
  cleanMpLoginKey() {
    localStorage.removeItem(MP_LOGIN_KEY);
  }
  /**
   * @description 停止小程序登录轮询
   * @function stopMpLogin
   */
  stopMpLogin() {
    if (this.pollingTimer) {
      clearTimeout(this.pollingTimer);
      this.pollingTimer = null;
    }
    if (this.pollingPromise) {
      this.pollingPromise = null;
    }
  }
}
export default new Login();
